module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-table-section"
  }, [_c('div', {
    staticClass: "stock-table-toolbar"
  }, [_c('div', {
    staticClass: "stock-table-toolbar-left"
  }, [_c('span', {
    staticClass: "stock-table-title"
  }, [_vm._v("\n        Inventory Table\n        "), _c('span', {
    staticClass: "stock-table-count"
  }, [_vm._v(" " + _vm._s(_vm.products.length) + " products")])])]), _vm._v(" "), _c('div', {
    staticClass: "stock-table-toolbar-right"
  }, [_c('form', {
    staticClass: "stock-search-wrapper",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "search icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "prevent-autofill",
      rawName: "v-prevent-autofill",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "stock-search-input",
    attrs: {
      "type": "search",
      "placeholder": "Search products..."
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function($event) {
        return _vm.$emit('search', $event.target.value)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search', $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "stock-inventory-table"
  }, [_vm._m(0), _vm._v(" "), _c('thead', [_c('tr', [_c('th', [_vm._v("Product")]), _vm._v(" "), _vm._l((_vm.sortableColumns), function(col) {
    return _c('th', {
      key: col.key,
      class: ['text-' + col.align, 'th-sort']
    }, [_c('span', {
      staticClass: "sort-col-head",
      class: _vm.headClass(col.key),
      attrs: {
        "role": "button",
        "tabindex": "0",
        "title": 'Sort by ' + col.label
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('sort', col.key)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          $event.preventDefault();
          return _vm.$emit('sort', col.key)
        }
      }
    }, [_vm._v("\n              " + _vm._s(col.label) + "\n              "), _c('span', {
      staticClass: "sort-col-icons",
      attrs: {
        "aria-hidden": "true"
      }
    }, [(_vm.sortKey === col.key && _vm.sortDir === 'asc') ? _c('svg', {
      staticClass: "sort-icon-filled",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M12 8l7 9H5z"
      }
    })]) : (_vm.sortKey === col.key && _vm.sortDir === 'desc') ? _c('svg', {
      staticClass: "sort-icon-filled",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M12 16l-7-9h14z"
      }
    })]) : _c('svg', {
      staticClass: "sort-icon-neutral",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('path', {
      attrs: {
        "d": "M7 15l5 5 5-5M7 9l5-5 5 5"
      }
    })])])])])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.products), function(product) {
    return _c('tr', {
      key: product.productId
    }, [_c('td', [_c('div', {
      staticClass: "stock-product-cell"
    }, [_c('img', {
      staticClass: "stock-product-img",
      attrs: {
        "src": product.imageUrl || product.largeImageUrl
      },
      on: {
        "click": function($event) {
          return _vm.$emit('show-details', product.productId)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "stock-product-info"
    }, [_c('span', {
      staticClass: "stock-product-title",
      attrs: {
        "title": product.productTitle
      }
    }, [_vm._v(_vm._s(product.productTitle))]), _vm._v(" "), _c('div', {
      staticClass: "stock-product-meta"
    }, [_c('span', {
      staticClass: "stock-product-asin"
    }, [_vm._v(_vm._s(product.asin || String(product.productId || '')))]), _vm._v(" "), _c('span', {
      staticClass: "stock-product-separator"
    }, [_vm._v("|")]), _vm._v(" "), _c('i', {
      class: product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin": "0"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(product.marketplace))])])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-qty-cell"
    }, [_c('div', {
      class: ['stock-qty-main', {
        'stock-qty-transferring': product._isTransferring
      }]
    }, [_vm._v("\n                " + _vm._s(product._fbaTotal) + "\n              ")]), _vm._v(" "), (product.fbaStockDetails) ? [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v(_vm._s(product.fbaStockDetails))])] : (product._fulfillable === 0) ? [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Fulfillable: " + _vm._s(product._fulfillable))]), _vm._v(" "), (product._reserved > 0) ? _c('div', {
      staticClass: "stock-transfer-pill"
    }, [_c('i', {
      staticClass: "exchange icon"
    }), _vm._v("\n                  " + _vm._s(product._reserved) + " transferring between FCs\n                ")]) : _vm._e(), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("\n                  Inbound: " + _vm._s(_vm.fmtNum(product.fbaInbound)) + "\n                ")]) : _vm._e()] : [_c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Fulfillable: " + _vm._s(product._fulfillable))]), _vm._v(" "), _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Transferring: " + _vm._s(product._reserved))]), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("\n                  Inbound: " + _vm._s(_vm.fmtNum(product.fbaInbound)) + "\n                ")]) : _vm._e()]], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-qty-cell"
    }, [(product.fbmStock != null && product.fbmStock > 0) ? [_c('div', {
      staticClass: "stock-qty-main"
    }, [_vm._v(_vm._s(product.fbmStock))]), _vm._v(" "), _c('div', {
      staticClass: "stock-qty-detail"
    }, [_vm._v("Own warehouse")])] : _c('div', {
      staticClass: "stock-qty-main stock-qty-na"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-velocity-cell"
    }, [(product.velocity !== null && product.velocity !== undefined) ? [_c('div', {
      staticClass: "stock-velocity-value"
    }, [_vm._v(_vm._s(product.velocity) + "/day")]), _vm._v(" "), _c('div', {
      class: ['stock-velocity-trend', product._trendCls]
    }, [_vm._v(_vm._s(product._trendText))])] : _c('div', {
      staticClass: "stock-velocity-value stock-velocity-placeholder"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "stock-days-cell"
    }, [(product.daysLeft !== null && product.daysLeft !== undefined) ? [_c('div', {
      class: ['stock-days-value', product.healthStatus || '']
    }, [_vm._v("\n                  " + _vm._s(product.daysLeftDisplay || (product.daysLeft + ' days')) + "\n                ")]), _vm._v(" "), (product.daysLeftSubtitle) ? _c('div', {
      staticClass: "stock-days-detail"
    }, [_vm._v(_vm._s(product.daysLeftSubtitle))]) : _vm._e(), _vm._v(" "), (product.fbaInbound > 0) ? _c('div', {
      staticClass: "stock-inbound-badge-wrapper"
    }, [_c('div', {
      staticClass: "stock-inbound-badge"
    }, [_c('i', {
      staticClass: "info circle icon"
    }), _vm._v("\n                    +" + _vm._s(product.fbaInbound) + " inbound not counted\n                  ")])]) : _vm._e()] : _c('div', {
      staticClass: "stock-days-value stock-days-placeholder"
    }, [_vm._v("—")])], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: ['stock-status-badge', product.healthStatus || 'unknown']
    }, [_vm._v("\n              " + _vm._s(product.status || 'Unknown') + "\n            ")])])])
  }), _vm._v(" "), (_vm.products.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "stock-empty-state"
  }, [_c('i', {
    staticClass: "warehouse icon"
  }), _vm._v(" "), (_vm.searchQuery) ? _c('p', [_vm._v("No products match your search.")]) : _c('p', [_vm._v("No inventory data available yet.")])])])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.products.length > 0) ? _c('div', {
    staticClass: "stock-table-legend"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('div', {
    staticClass: "stock-pagination"
  }, [_c('button', {
    staticClass: "stock-pagination-btn",
    class: {
      disabled: _vm.currentPage === 0
    },
    on: {
      "click": function($event) {
        return _vm.$emit('page', _vm.currentPage - 1)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon",
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _vm._l((_vm.paginationPages), function(page) {
    return _c('button', {
      key: page,
      class: ['stock-pagination-btn', {
        active: _vm.currentPage === page
      }],
      on: {
        "click": function($event) {
          return _vm.$emit('page', page)
        }
      }
    }, [_vm._v("\n      " + _vm._s(page + 1) + "\n    ")])
  }), _vm._v(" "), _c('button', {
    staticClass: "stock-pagination-btn",
    class: {
      disabled: _vm.currentPage >= _vm.totalPages - 1
    },
    on: {
      "click": function($event) {
        return _vm.$emit('page', _vm.currentPage + 1)
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon",
    staticStyle: {
      "margin": "0"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "stock-pagination-info"
  }, [_vm._v("\n      Page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.totalPages) + " (" + _vm._s(_vm.totalItems) + " items)\n    ")])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "stock-col-product"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-fba"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-fbm"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-velocity"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-runway"
  }), _vm._v(" "), _c('col', {
    staticClass: "stock-col-status"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-legend-header"
  }, [_c('div', {
    staticClass: "stock-legend-title"
  }, [_vm._v("Status logic:")]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-items"
  }, [_c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot critical"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Out of Stock")]), _vm._v(" — Fulfillable + Transferring = 0, no inbound")])]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot low"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Low Stock")]), _vm._v(" — Effective runway ≤ 14 days")])]), _vm._v(" "), _c('div', {
    staticClass: "stock-legend-item"
  }, [_c('span', {
    staticClass: "stock-legend-dot healthy"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Healthy")]), _vm._v(" — Effective runway > 14 days")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-legend-note"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Effective Stock = Fulfillable + Transferring (reservedStock). Inbound (not yet at FC) shown as info — excluded from runway.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ca22610!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/StockInventoryTable.vue
// module id = 796
// module chunks = 2